import React from 'react';
import useOrganizationGroups from '../../../../../../../hooks/api/useOrganizationGroups';
import { AnimateLoadedContent } from '../../../../../../v2BaseComponents/Loader';
import SideDrawerFormContainer, {
    ConfirmDirtyStateFormCloseContainer,
} from '../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import BulkAddClientProfilesGroups from '../../../../../../shared/BulkAddClientProfilesGroups';
import { useOrganizationClientRecords } from '../../../../../../../hooks/api/useOrganizationClientRecords';

export type BulkAddClientProfilesGroupsSideDrawerContentProps = {
    clientRecordIds: string[];
    onClose: (force: boolean) => void;
};

const BulkAddClientProfilesGroupsSideDrawerContent: React.FC<BulkAddClientProfilesGroupsSideDrawerContentProps> = ({
    clientRecordIds,
    onClose,
}) => {
    const { bulkAddClientRecordsToGroups, isBulkAddingClientRecordsToGroups } = useOrganizationClientRecords({
        onBulkAddClientRecordsToGroupsSuccess: () => onClose(true),
    });

    const { isLoadingGroups, groups } = useOrganizationGroups({});
    const [selectedGroupIds, setSelectedGroupIds] = React.useState<string[]>([]);

    return (
        <AnimateLoadedContent isLoading={isLoadingGroups || isBulkAddingClientRecordsToGroups}>
            {() => (
                <ConfirmDirtyStateFormCloseContainer>
                    <SideDrawerFormContainer
                        onCancel={() => onClose(true)}
                        onSubmit={() => {
                            bulkAddClientRecordsToGroups({
                                organizationGroupIds: selectedGroupIds,
                                organizationClientRecordIds: clientRecordIds,
                            });
                        }}
                        isDisabled={setSelectedGroupIds.length === 0}
                    >
                        <BulkAddClientProfilesGroups
                            organizationGroups={groups}
                            selectedGroupIds={selectedGroupIds}
                            onSelectedGroupIdsChange={setSelectedGroupIds}
                            clientRecordIds={clientRecordIds}
                        />
                    </SideDrawerFormContainer>
                </ConfirmDirtyStateFormCloseContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(BulkAddClientProfilesGroupsSideDrawerContent);
